import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

// Utils
import { getGoogleCredentials } from 'util/credentials';

// Actions
import { setCurrentMapZoom as setCurrentMapZoomAction } from 'current';

// Selectors
import { getBoundariesByFieldUuid } from 'boundaries/selectors';
import {
  getActiveFieldUuid,
  getActiveTrialPlacementsScript
} from 'current/selectors';
import { isAppMode as isAppModeActive } from 'settings/selectors';

// Components
import BaseMap from 'mapping/BaseMap';
import FieldLayer from 'mapping/layers/FieldLayer';
import TrialPlacementLayer from 'mapping/layers/TrialPlacementLayer';

/** Component for rendering map on Script Manager screen.  */
let TrialPlacementMapContainer = ({
  boundaries,
  isAppMode,
  script,
  setCurrentMapZoom
}) => (
  <div className="vra-map-panel">
    <div className="vra-map-wrapper">
      <BaseMap
        bounceAtZoomLimits={!isAppMode}
        boundaries={boundaries}
        className="vra-map"
        googleCredentials={getGoogleCredentials()}
        isAppMode={isAppMode}
        onLeafletZoomEnd={(event) => setCurrentMapZoom(event.target.getZoom())}
        showScale={true}
      >
        {boundaries && (
          <FieldLayer boundaryGeoJson={boundaries} color="#9527AF" />
        )}
        {script && <TrialPlacementLayer script={script} />}
      </BaseMap>
    </div>
  </div>
);

TrialPlacementMapContainer.propTypes = {
  boundaries: propTypes.object,
  isAppMode: propTypes.bool.isRequired,
  script: propTypes.object,
  setCurrentMapZoom: propTypes.func.isRequired,
  zones: propTypes.object
};

TrialPlacementMapContainer = connect(
  (state) => {
    const fieldUuid = getActiveFieldUuid(state);
    const script = getActiveTrialPlacementsScript(state);

    return {
      boundaries: getBoundariesByFieldUuid(state, fieldUuid),
      isAppMode: isAppModeActive(state),
      script: script
    };
  },
  (dispatch) => {
    return {
      setCurrentMapZoom: (zoom) => {
        dispatch(setCurrentMapZoomAction(zoom));
      }
    };
  }
)(TrialPlacementMapContainer);

export default TrialPlacementMapContainer;
